export default class ScrollSpy {

  constructor(el, cb,isHorizontal = false) {
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    this.el = el;
    this.callback = cb;
    this.isHorizontal = isHorizontal
    this.currentScrollY = this.prevScrollY = this.getScrollPosition();
    this.ticking = false;

    this.el.addEventListener('scroll', this.onScroll, false);
  }
  
  getScrollPosition(){
    return this.isHorizontal ? this.el.scrollLeft : this.el.scrollTop;
  }

  onScroll() {
    this.currentScrollY = this.getScrollPosition();
    this.requestTick();
  }

  requestTick() {
    if( ! this.ticking ) requestAnimationFrame(this.update);
    this.ticking = true;
  }

  update() {
    this.ticking = false;

    // Trigger the callback, passing in latest scroll values
    let scrollDirection = this.currentScrollY > this.prevScrollY ? 'positive' : 'negative';
    this.callback(this.currentScrollY, scrollDirection);

    this.prevScrollY = this.currentScrollY;
  }

  destroy() {
    this.el.removeEventListener('scroll', this.onScroll);
  }
}